var codeblock_default = {
  "blockStyleSpacing": "_8e-XY",
  "codeBlock": "Mp-Fk _8e-XY",
  "renderedInTable": "-GyXk"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
